// extracted by mini-css-extract-plugin
export default {"hed":"Xk","blend":"Yk","resultsBox":"Zk","left":"al","right":"bl","center":"cl","base":"el","milk":"fl","text":"gl","hyroxresult":"hl","margin":"il"};
    if(module.hot) {
      // 1713969923367
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  